class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartButton = document.querySelector(`${selectorsElement.headerClass} ${selectorsElement.cartButton}`);
    this.headerTopDefault = document.querySelector(`${selectorsElement.headerClass}`);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    document.addEventListener('click', (event) => this.handleOutsideClick(event));
    this.setHeaderCartIconAccessibility();
  }

  handleOutsideClick(event) {
    const cartButtons = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.cartButton}`);
    const isClickInsideCartButton = Array.from(cartButtons).some(button => button.contains(event.target));

    if (!this.contains(event.target) && !isClickInsideCartButton) {
      this.close();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLinkMobile = document.querySelector('#cart-icon-bubble-mobile');
    const headerClass = document.querySelector(`${selectorsElement.headerClass}`);
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    if (cartLinkMobile){
      cartLinkMobile.setAttribute('role', 'button');
      cartLinkMobile.setAttribute('aria-haspopup', 'dialog');
    }


    if(headerClass){
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        if(cartLink.classList.contains('active')){
          cartLink.classList.remove('active');
          this.close(cartLink);
        }else{
          cartLink.classList.add('active');
          this.open(cartLink);
        }

      });

      cartLinkMobile.addEventListener('click', (event) => {
        event.preventDefault();
        if(cartLinkMobile.classList.contains('active')){
          cartLinkMobile.classList.remove('active');
          this.close(cartLinkMobile);
        }else{
          cartLinkMobile.classList.add('active');
          this.open(cartLinkMobile);
        }

      });
    }else{
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        cartLink.classList.add('active');
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

  }

  removeClassModal() {
    const modalActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.modal}`)
    const headerIconActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.headerIconClass}`)
    modalActive.forEach((modal)=> {
        modal.classList.remove('active');
    })

    headerIconActive.forEach((icon)=>{
        icon.classList.remove('active');
    })
  }

  open(triggeredBy) {
    const buttonCart = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.headerCartButtonDropdown}`);
    if(buttonCart){
      buttonCart.forEach((button)=>{
        button.classList.add('active');
      })
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

  }

  close() {
    this.removeClassModal();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    this.headerTopDefault = document.querySelector(`${selectorsElement.headerClass}`);
    let idDefault = 'cart-drawer';
    if(this.headerTopDefault) idDefault= 'tso-cart-drawer';
    return [
      {
        id: idDefault,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    this.headerTopDefault = document.querySelector(`${selectorsElement.headerClass}`);
    let idDefault = 'cart-drawer';
    if(this.headerTopDefault) idDefault= 'tso-cart-drawer';
    return [
      {
        id: 'CartDrawer',
        section: idDefault,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
